export enum EnumTemporality {
  Monthly = 1,
  Quarterly = 3,
  Biannual = 6,
  Annual = 12,
  Cancelation = 0
}
